{% block sw_cms_block_acris_faq_preview %}
    <div class="sw-cms-preview-acris-faq">

        <div class="acris-faq-question-title">
            <p>Lorem ipsum?</p><span>+</span>
        </div>
        <div class="acris-faq-question-content">
            <p>Lorem ipsum dolor sit amet.</p>
        </div>

    </div>
{% endblock %}
